module.exports = __webpack_public_path__ + "img/pay.fce3af4a.jpg";